import { combineReducers } from "redux";

import isAuth from "./auth/reducers";
import tokenInfo from "./tokens/reducers";
import mobileConnectionInfo from "./mobileConnection/reducers";
import contractInfo from "./contract/reducers";

const reducers = combineReducers({
  isAuth,
  tokenInfo,
  contractInfo,
  mobileConnectionInfo,
});

export default reducers;
